import { useState } from "react";
import { useTheme } from "../ThemeContext";
import T from "../i18n";

export default function Sidebar({ page, setPage, relGrupo, setRelGrupo, relSub, setRelSub, cadSub, setCadSub, cfgSub, setCfgSub, collapsed, novos, clock, lang, nomeLoja, onLogout }) {
  const { theme: C } = useTheme();
  const [openMenus, setOpenMenus] = useState({});
  const _ = (k) => T(lang, k);

  const relMenu = [
    { key: "pedidos", label: _("pedidos"), subs: [
      { key: "vendidos", label: _("vendidos") }, { key: "cancelados", label: _("cancelados") },
      { key: "dia", label: _("dia") }, { key: "mes", label: _("mes") }, { key: "ano", label: _("ano") },
    ]},
    { key: "financeiro", label: _("financeiro"), subs: [
      { key: "geral", label: _("pagamentos") }, { key: "dinheiro", label: _("dinheiro") },
      { key: "credito", label: _("cartao") }, { key: "pix", label: _("pix") }, { key: "cashback", label: _("cashback") },
    ]},
    { key: "entregadores", label: _("entregadores"), subs: [
      { key: "geral", label: _("geral") }, { key: "por_entregador", label: _("porEntregador") },
      { key: "dia", label: _("dia") }, { key: "mes", label: _("mes") }, { key: "ano", label: _("ano") },
      { key: "pagos", label: _("pagos") }, { key: "a_receber", label: _("aReceber") }, { key: "saldo", label: _("saldo") },
    ]},
  ];

  const cadMenu = [
    { key: "categorias",    label: _("categorias") },
    { key: "subcategorias", label: _("subCategorias") },
    { key: "produtos",      label: _("produtos") },
    { key: "adicionais",    label: _("adicionais") },
    { key: "caixinha",      label: _("caixinhaSurpresa") },
    { key: "promocoes",     label: "Promoções do Dia" },
  ];

  const cfgMenu = [
    { key: "configuracao_tela", label: "Configuração de Tela" },
    { key: "horarios",          label: _("horarios") },
    { key: "dados_conta",       label: _("dadosConta") },
    { key: "api_pagamento",     label: _("apiPagamento") },
    { key: "impressora",        label: _("impressora") },
    { key: "tipos_pagamento",   label: _("tiposPagamento") },
    { key: "idiomas",           label: _("idiomas") },
  ];

  const toggle = (key) => setOpenMenus(prev => ({ ...prev, [key]: !prev[key] }));
  const goTo = (p) => setPage(p);

  const renderRelatorios = () => (
    <>
      <NavItem C={C} label={_("relatorios")} short="Rel" active={page === "relatorios"} collapsed={collapsed}
        hasArrow arrowOpen={openMenus.rel}
        onClick={() => { toggle("rel"); if (page !== "relatorios") { setPage("relatorios"); setOpenMenus(p => ({ ...p, rel: true })); if (!relGrupo) { setRelGrupo("pedidos"); setRelSub("vendidos"); } } }}
      />
      {openMenus.rel && !collapsed && (
        <div style={{ marginLeft: 16, borderLeft: `2px solid ${C.border}`, paddingLeft: 8, marginBottom: 6, animation: "fadeUp .2s ease-out" }}>
          {relMenu.map(grupo => (
            <div key={grupo.key}>
              <div className="sub-g" onClick={() => { toggle(`rel_${grupo.key}`); setRelGrupo(grupo.key); setRelSub(grupo.subs[0].key); setPage("relatorios"); }}
                style={{ display: "flex", alignItems: "center", padding: "8px 10px", fontSize: 13, fontWeight: 700, marginBottom: 1, borderRadius: 8, cursor: "pointer", color: relGrupo === grupo.key ? C.text : C.textSoft, transition: "all .15s" }}>
                <span style={{ flex: 1 }}>{grupo.label}</span>
                <span style={{ fontSize: 9, transition: "transform .2s", transform: openMenus[`rel_${grupo.key}`] ? "rotate(180deg)" : "rotate(0deg)", opacity: .5 }}>▼</span>
              </div>
              {openMenus[`rel_${grupo.key}`] && (
                <div style={{ marginLeft: 12, borderLeft: `1px solid ${C.border}30`, paddingLeft: 8, marginBottom: 4 }}>
                  {grupo.subs.map(sub => (
                    <div key={sub.key} className="sub-s" onClick={() => { setRelGrupo(grupo.key); setRelSub(sub.key); setPage("relatorios"); }}
                      style={{ padding: "6px 10px", fontSize: 12, fontWeight: 600, marginBottom: 1, borderRadius: 6, color: relGrupo === grupo.key && relSub === sub.key ? C.red : C.textMuted, background: relGrupo === grupo.key && relSub === sub.key ? `${C.red}15` : "transparent", cursor: "pointer", transition: "all .15s" }}>
                      {sub.label}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </>
  );

  const renderSubMenu = (menuKey, pageName, label, short, items, activeSub, setActiveSub) => (
    <>
      <NavItem C={C} label={label} short={short} active={page === pageName} collapsed={collapsed}
        hasArrow arrowOpen={openMenus[menuKey]}
        onClick={() => { toggle(menuKey); if (page !== pageName) { setPage(pageName); setOpenMenus(p => ({ ...p, [menuKey]: true })); if (!activeSub) setActiveSub(items[0].key); } }}
      />
      {openMenus[menuKey] && !collapsed && (
        <div style={{ marginLeft: 16, borderLeft: `2px solid ${C.border}`, paddingLeft: 8, marginBottom: 6, animation: "fadeUp .2s ease-out" }}>
          {items.map(sub => (
            <div key={sub.key} className="sub-s" onClick={() => { setActiveSub(sub.key); setPage(pageName); }}
              style={{ padding: "7px 10px", fontSize: 12, fontWeight: 600, marginBottom: 1, borderRadius: 6, color: page === pageName && activeSub === sub.key ? C.red : C.textMuted, background: page === pageName && activeSub === sub.key ? `${C.red}15` : "transparent", cursor: "pointer", transition: "all .15s" }}>
              {sub.label}
            </div>
          ))}
        </div>
      )}
    </>
  );

  return (
    <div style={{ width: collapsed ? 68 : 240, minWidth: collapsed ? 68 : 240, background: C.sidebar, borderRight: `1px solid ${C.border}`, padding: collapsed ? "20px 10px" : "20px 16px", display: "flex", flexDirection: "column", position: "sticky", top: 0, height: "100vh", transition: "all .3s ease", overflowY: "auto", overflowX: "hidden" }}>

      {/* Logo */}
      <div style={{ textAlign: "center", marginBottom: 6, padding: collapsed ? "0" : "0 8px" }}>
        <div style={{ fontFamily: "'Plus Jakarta Sans'", fontWeight: 800, fontSize: collapsed ? 14 : 22, lineHeight: 1 }}>
          <span style={{ color: C.red }}>Mix</span><span style={{ color: C.green }}>Up</span>
        </div>
        {!collapsed && <div style={{ fontSize: 10, color: C.textMuted, fontWeight: 600, letterSpacing: "0.08em", textTransform: "uppercase", marginTop: 4 }}>{_("painelLojista")}</div>}
      </div>

      {/* Nome da loja */}
      {!collapsed && nomeLoja && (
        <div style={{ textAlign: "center", padding: "6px 10px", borderRadius: 8, background: `${C.red}10`, border: `1px solid ${C.red}25`, marginBottom: 8 }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: C.red, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{nomeLoja}</div>
        </div>
      )}

      <div style={{ height: 1, background: C.border, margin: "10px 0 14px" }} />
      {!collapsed && <div style={{ fontSize: 10, fontWeight: 700, color: C.textMuted, letterSpacing: "0.12em", padding: "0 10px 10px", textTransform: "uppercase" }}>{_("menu")}</div>}

      {/* Itens do menu */}
      <NavItem C={C} label={_("dashboard")} short="Dash" active={page === "dashboard"} collapsed={collapsed} onClick={() => goTo("dashboard")} />
      <NavItem C={C} label={_("pedidos")} short="Ped" active={page === "pedidos"} collapsed={collapsed} badge={novos} onClick={() => goTo("pedidos")} />
      <NavItem C={C} label="Entregadores" short="Ent" active={page === "entregadores"} collapsed={collapsed} onClick={() => goTo("entregadores")} />
      <NavItem C={C} label="Bot WhatsApp" short="Bot" active={page === "bot"} collapsed={collapsed} onClick={() => goTo("bot")} />
      {renderRelatorios()}
      {renderSubMenu("cad", "cadastro", _("cadastro"), "Cad", cadMenu, cadSub, setCadSub)}
      {renderSubMenu("cfg", "config", _("configuracao"), "Cfg", cfgMenu, cfgSub, setCfgSub)}

      {/* Rodapé: horário + Sair */}
      <div style={{ marginTop: "auto", borderTop: `1px solid ${C.border}`, paddingTop: 12 }}>
        <div style={{ textAlign: "center", padding: collapsed ? "4px 0" : "4px 10px", marginBottom: 8 }}>
          {!collapsed && <div style={{ fontSize: 11, color: C.textMuted }}>mixupbr.com.br</div>}
          <div style={{ fontSize: collapsed ? 12 : 20, fontWeight: 800, color: C.textSoft, marginTop: collapsed ? 0 : 4 }}>
            {clock.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })}
          </div>
        </div>

        <div className="nav-item" onClick={onLogout}
          style={{ display: "flex", alignItems: "center", justifyContent: collapsed ? "center" : "flex-start", padding: collapsed ? "10px 0" : "10px 14px", fontSize: 13, fontWeight: 700, borderRadius: 10, cursor: "pointer", color: C.red, border: `1px solid ${C.red}30`, background: `${C.red}08` }}>
          {collapsed ? "↩" : "Sair"}
        </div>
      </div>
    </div>
  );
}

function NavItem({ label, short, active, collapsed, badge, hasArrow, arrowOpen, onClick, C, icon }) {
  return (
    <div className="nav-item" onClick={onClick} style={{ display: "flex", alignItems: "center", justifyContent: collapsed ? "center" : "flex-start", padding: collapsed ? "12px 0" : "12px 14px", fontSize: collapsed ? 11 : 14, fontWeight: 600, marginBottom: 2, borderRadius: 10, position: "relative", background: active ? `linear-gradient(135deg, ${C.red}, ${C.red}CC)` : "transparent", color: active ? "#fff" : C.textSoft, boxShadow: active ? `0 4px 20px ${C.red}30` : "none", gap: 6 }}>
      {icon && <span style={{ fontSize: collapsed ? 14 : 16 }}>{icon}</span>}
      <span style={{ flex: collapsed ? undefined : 1 }}>{collapsed ? (short || label.slice(0, 3)) : label}</span>
      {hasArrow && !collapsed && <span style={{ fontSize: 10, transition: "transform .2s", transform: arrowOpen ? "rotate(180deg)" : "rotate(0deg)", opacity: .6 }}>▼</span>}
      {badge > 0 && <span style={{ position: collapsed ? "absolute" : "static", top: collapsed ? 2 : undefined, right: collapsed ? 2 : undefined, background: active ? "rgba(255,255,255,.2)" : C.red, color: "#fff", fontSize: collapsed ? 9 : 11, fontWeight: 800, padding: collapsed ? "1px 5px" : "2px 8px", borderRadius: 8 }}>{badge}</span>}
    </div>
  );
}
